/** @format */

export * from './product-title.module';
